<template>
	<div class="d-inline-block justify-content-center">
		<div class="d-inline-block mx-1" v-for="(item, index) in fontStyles.types" :key="index">
			<SelectButton v-model="fontStyles.selectedOptions[index].options" :options="item.options" aria-labelledby="custom" :multiple="item.multiSelect" @change="updateStyle" v-if="item.visible" >
				<template #option="slotProps">
					<span class="material-symbols-outlined">{{ slotProps.option.icon }}</span>
				</template>
			</SelectButton>
		</div>
	</div>
</template>

<script lang="ts">
	import {defineComponent} from "vue";
	
	export default defineComponent({
		emits: ['update-style-event'],
		props: {
			styles:{
				type: Object,
				required: true,
			}
		},
		computed:{
			fontStyles(){
				return this.styles;
			}
		},
		methods: {
			updateStyle() {
				this.$emit('update-style-event', this.fontStyles);
			}
		}
	})
</script>